// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1164":"65e537bb","2589":"d6fdf0fb","7116":"07626bd9","8891":"e20fa3bb"}[chunkId] + ".css";
};